import { render, staticRenderFns } from "./SkupSuorganizatorBase.vue?vue&type=template&id=6dc7f889&scoped=true&"
import script from "./SkupSuorganizatorBase.vue?vue&type=script&lang=js&"
export * from "./SkupSuorganizatorBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc7f889",
  null
  
)

export default component.exports